module.exports = __webpack_public_path__ + "static/media/lenovo-tablette.0318b15e.jpg";